import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=47baa231"
import script from "./welfare.vue?vue&type=script&lang=js"
export * from "./welfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports